<script>
/* ------------------------------------------------------------------------------------------
Main component for the entire app. Page constits of the NavBar, the views (router-view) and footer
---------------------------------------------------------------------------------------------*/

import NavBar from '@/components/NavBar.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'App',

  components: {
    NavBar,
    Footer
  },

  created() {},

  computed: {}
}
</script>

<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <NavBar />
    </v-app-bar>

    <!-- <v-spacer></v-spacer> -->

    <v-main id="v-main">
      <router-view :key="$route.fullPath" />
      <Footer />
    </v-main>
  </v-app>
</template>

<style>
html {
  /* from vuemastery */
  -webkit-text-size-adjust: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0px;
  font-family: Candara, Verdana, Arial, sans-serif;
  font-size: 10pt;
  background-color: #000033;
  color: #ccccff;
}

#app {
  width: 100%;
  height: 100%;
  position: relative;
  /* from vuemastery */
  /* box-sizing: border-box;
  padding: 0 20px 20px;
  margin: 0 auto; */
}

/*
#v-main {
  width: 100%;
  height: 100%;
}*/

hr {
  /* from vuemastery - not sure if used */
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

a {
  /* from vuemastery */
  color: #39b982;
  font-weight: 600;
  background-color: transparent;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  /* from vuemastery */
  display: flex;
  align-items: center;
  font-family: 'Montserrat', sans-serif;
}

h1 {
  font-size: 1em;
}

h2 {
  margin: 0px;
  display: block;
  font-size: 1.3em;
  font-weight: bold;
  color: #000033;
}

h3 {
  margin: 0px;
  color: #cce6ff;
  font-size: 100%;
  font-weight: bold;
  padding: 4px;
}

/* from vuemastery */
button,
label,
input,
optgroup,
select,
textarea {
  display: inline-flex;
  font-family: 'Open sans', sans-serif;
  font-size: 100%;
  line-height: 1.15;
  margin: 0;
}

/* from vuemastery */
button,
input {
  overflow: visible;
}

/* from vuemastery */
button,
select {
  text-transform: none;
}

/* from vuemastery */
button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: none;
}

/* from vuemastery */
button::-moz-focus-inner,
[type='button']::-moz-focus-inner,
[type='reset']::-moz-focus-inner,
[type='submit']::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/* from vuemastery */
button:-moz-focusring,
[type='button']:-moz-focusring,
[type='reset']:-moz-focusring,
[type='submit']:-moz-focusring {
  outline: 2px solid #39b982;
}

ul {
  margin: 0px;
}

.-text-error {
  color: red;
}

.-text-success {
  color: black;
}
</style>
